import { request } from '@helpers/request';

/**
 * Get the location list
 */
const getLocationsListApi = () => request('locations');

export default getLocationsListApi;
